export const getCookie = (cname: any) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const updateCookie = (token: any) => {
    let now = new Date();
    now.setHours(now.getHours() + 3);
    document.cookie = `avian-auth=${token};path=/;expires=${now.toUTCString()};SameSite=Lax;`;
}